import { useState, type ReactNode } from 'react'
import { createReportNavigationState } from '@/lib/reports/navigation-state'
import { ReportNavigationContext } from './navigation-context'

export function ReportNavigationProvider({ children }: { children: ReactNode }) {
  const [navigation] = useState(createReportNavigationState)
  return <ReportNavigationContext.Provider value={navigation}>{children}</ReportNavigationContext.Provider>
}
